import { Component } from '@angular/core';
import {  OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription,Observable } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../../service/root.service';

import { Role } from '../shared/role';
import { RoleService } from '../shared/role.service';

import { ConfirmationService } from 'primeng/primeng';

import { enDefualt, arDefualt } from '../../../shared/config';
import * as moment from 'moment';

@Component({
    selector: 'roles',
    templateUrl: './roles.component.html',
    styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit, OnDestroy {

    @Input() selectedRole;
    @Output() selectedRoleChange = new EventEmitter();
    @Input() operation: string;
    fromRoute: boolean;

    roles: Role[];
    


    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;

    constructor(public rootService: RootService,
        public roleService: RoleService,
        public route: ActivatedRoute,
        public router: Router,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) {
            translate.onLangChange.subscribe((event) => {
                this.translateList();
            });

    }

    dateSort(event, DateField) {

        let comparer = function (a, b): number {
            let result: number = -1;

            if (a[DateField].ms > b[DateField].ms) result = 1;
            return result * event.order;
        };

        this.roles.sort(comparer);
    }

    translateList(){
        
    }

    getRoles() {
        this.roles = null;
        this.requestError = false;
        this.noResult = false;
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        this.requestXHR = this.roleService.getAll()
            .subscribe(
            items => {
                if (items.roles.length == 0) {
                    this.roles = [];
                    this.noResult = true;
                } else {
                    this.roles = items.roles;
                    this.translateList();
                }
                


            },
            err => {
                this.requestError = true;
                this.rootService.toast.showErrorCode(err.code);
            });
    }
    getRole(role, operation) {

        if (operation == 'edit') {
            this.router.navigateByUrl('admin/role/' + role._id + '/update');
        } else if (operation == 'clone') {
            this.router.navigateByUrl('admin/role/' + role._id + '/clone');
        } else {
            this.router.navigate(['admin/role', role._id]);
        }



    }
    emitRole(role) {
        this.selectedRole = role;
        this.selectedRoleChange.emit(this.selectedRole);
    }
    deleteRole(id: number) {
        this.confirmationService.confirm({
            message: this.translate.instant('form.common.deleteQ', { 'item': this.translate.instant('ctrl.role.view.header.one') }),
            header: this.translate.instant('form.common.delete'),
            icon: 'fa fa-trash',
            accept: () => {
                this.roleService.delete(id)
                    .subscribe(
                    items => {
                        this.roles = this.roles.filter(role => role._id !== id);
                        this.rootService.toast.showSuccess(this.translate.instant('form.common.deleteItem', { 'item': this.translate.instant('ctrl.role.view.header.one') }));
                    }, //Bind to view
                    err => {
                        this.rootService.toast.showErrorCode(err.code);
                    });
            }
        });

    }
    ngOnInit() {


        this.getRoles();

    }

    ngOnDestroy() {
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        if (this.routeEvent) {
            this.routeEvent.unsubscribe();
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/module/role/roles/roles.component.ts